
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"100","height":"100","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M75.337 55.531l-10.004-5.504 10.004-5.504a1.49 1.49 0 00.742-.996 1.484 1.484 0 00-.266-1.215L51.504 9.86a1.502 1.502 0 00-1.394-.96c-.219 0-.426.05-.613.132-.258.09-.492.242-.66.469L24.262 42.312a1.499 1.499 0 00.477 2.21l10.004 5.505-9.777 5.379a1.498 1.498 0 00-.496 2.617l24.098 32.18c.218.558.758.957 1.394.957.012 0 .024-.004.04-.004.01 0 .023.004.03.004.473 0 .918-.223 1.2-.602L75.81 57.746a1.5 1.5 0 00.265-1.215 1.486 1.486 0 00-.738-1zM48.466 85.058l-17.582-23.48 17.582 9.676v13.804zm3-13.805l17.832-9.812-17.832 23.812v-14zm10.039-22.539H61.5l-9.887 5.438L51.61 15l20.77 27.73-10.875 5.984zM48.61 14.808v39.43l-10.035-5.52c-.004 0-.004 0-.008-.003L27.696 42.73 48.61 14.808zm.703 43.238c.234.129.496.188.758.184.012 0 .023.004.039.004.367 0 .7-.137.96-.356l11.149-6.133 9.242 5.086-21.496 11.824-21.426-11.789 9.316-5.125 11.458 6.305z"}})])
          )
        }
      }
    